import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import {
  Form,
  Modal,
  Table,
} from "antd";
import { CallLanguageStore } from "../../../store";
import "./index.css";

function RowDetail() {
  const form = Form.useFormInstance();
  const { Column } = Table;

  return (
    <Fragment>
      <Modal
        width={"500px"}
        centered
        title={"录音播放"}
        open={CallLanguageStore.isOpenDetail}
        destroyOnClose={true}
        onCancel={() => CallLanguageStore.closeDetailModal()}
        footer={null}
        loading={CallLanguageStore.modalLoading}
      >
       <audio src={CallLanguageStore.recordData.data} controls></audio>
      </Modal>
    </Fragment>
  );
}

export default observer(RowDetail);
